import React from 'react'
import './About.css'
import ME from '../../assets/me.jpg';
import { FaAward } from 'react-icons/fa';
import {FiUsers} from 'react-icons/fi'
import {VscFolderLibrary} from 'react-icons/vsc'

const About = () => {
  return (
    <section id='about'>
      <h5>Get To Know</h5>
      <h2>About Me</h2>
      <div className="container about__container">
        <div className="about__me">
      <div className="about__me-image">
        <img src={ME} alt="myself" />
      </div>
        </div>
        <div className="about__content">
      <div className="about__cards">
        <article className='about-card'>
          <FaAward className='about-icon'/>
          <h5>Experience</h5>
          <small>2+ yrs experience</small>
        </article>
        <article className='about-card'>
          <FiUsers className='about-icon'/>
          <h5>Clients</h5>
          <small>20+ clients Ghana</small>
        </article>
        <article className='about-card'>
          <VscFolderLibrary className='about-icon'/>
          <h5>Projects</h5>
          <small>20+ Completed Projects</small>
        </article>
        </div>
        <p>Results driven computer programmer and web developer. Currently a student of kwame Nkrumah Univeristy of Science and Technology</p>
        <a href="#content" className='btn btn-primary'>Let's Talk</a>
      </div>
      </div>
    </section>
  )
}

export default About